import { useState } from 'react'
import { heapEvent } from '@equipmentshare/heaper'

import {
	EuiButton,
	EuiPopover,
	EuiContextMenuPanel,
	EuiContextMenuItem,
	EuiIcon

} from '@equipmentshare/ds2'

import {
	ArrowDownSLineIcon,
	ArrowUpSLineIcon,
	T3CostCaptureIcon,
	T3FleetIcon,
	ShareBoxFillIcon,
	SendPlane2LineIcon,
} from '@equipmentshare/ds2-icons'

import { getTransferPartsModal } from '../../reports/components/actionModals'

import { getExportCsvModal, getExportAdjustmentsCsvModal } from '../../inventory/components/actionModals'
import { useDispatchSetSelectedModal } from 'contexts/modal-context/modal-context'
import { useNavigate, useLocation } from 'react-router-dom'
import { useFlags } from '@equipmentshare/feature-flags'
import config from 'config/config'
import usePermissions from '../../../hooks/usePermissions'
import { checkPermissions } from '../../../components/PermissionsCheck/helpers'
import { Permission } from '../../../graphql'

export default function BasicActions() {
	const [ isPopoverOpen, setIsPopoverOpen ] = useState( false )
	const setSelectedModal = useDispatchSetSelectedModal()
	const location = useLocation()
	const navigate = useNavigate()
	const flags = useFlags()
	const { userPermissions } = usePermissions( [ Permission.CanCreateDemandRequestByStoreId ] )
	const userCanCreateRequest = checkPermissions( userPermissions, [ Permission.CanCreateDemandRequestByStoreId ] )

	const workOrderURL = config.ENVIRONMENT === 'production'
		? 'https://app.estrack.com/#/service/work-orders'
		: 'https://staging-app.estrack.com/#/service/work-orders'

	const costCaptureURL = config.ENVIRONMENT === 'production'
		? 'https://costcapture.estrack.com/purchase-orders/create'
		: 'https://staging-costcapture.estrack.com/purchase-orders/create'


	const togglePopover = () => setIsPopoverOpen( !isPopoverOpen )
	const closePopover = () => setIsPopoverOpen( false )

	const onClickTransferParts = () => {
		heapEvent( 'Inventory - Actions Dropdown - Click - Transfer Parts', {} )
		closePopover()
		setSelectedModal( getTransferPartsModal() )
	}
	const onClickExportCSV = () => {
		heapEvent( 'Inventory - Actions Dropdown - Click - Export CSV', {} )
		closePopover()
		setSelectedModal( getExportCsvModal() )
	}
	const onClickAddToInventory = () => {
		heapEvent( 'Inventory - Actions Dropdown - Click - Add to Inventory', {} )
		navigate( '/add', { state: { from: location.pathname } } )
	}

	const onClickExportAdjustmentsCSV = () => {
		heapEvent( 'Inventory - Actions Dropdown - Click - Export Adjustment CSV', {} )
		closePopover()
		setSelectedModal( getExportAdjustmentsCsvModal() )
	}

	const onClickRequestStock = () => {
		heapEvent( 'Inventory - Actions Dropdown - Click - Stock Request', {} )
		closePopover()
		navigate( '/requests/new', { state: { from: location.pathname } } )
	}

	const button = (
		<EuiButton
			fill
			iconSide="right"
			iconType={isPopoverOpen ? ArrowUpSLineIcon : ArrowDownSLineIcon}
			onClick={togglePopover}
		>
			Actions
		</EuiButton>
	)

	const items = [
		...( flags.costentoryEnableDemandRequests && userCanCreateRequest
			? [
				<EuiContextMenuItem
					key="requestStock"
					icon={<EuiIcon type={SendPlane2LineIcon} size="m" />}
					onClick={onClickRequestStock}
				>
					Stock Request
				</EuiContextMenuItem>
			]
			: []
		),
		<EuiContextMenuItem
			key="addToInventory"
			onClick={onClickAddToInventory}
		>
			Add to Inventory
		</EuiContextMenuItem>,
		<EuiContextMenuItem
			key="costCapturePo"
			icon={<EuiIcon type={T3CostCaptureIcon} size="m" />}
			href={costCaptureURL}
			target="_blank"
		>
			Create CostCapture PO <EuiIcon type={ShareBoxFillIcon} />
		</EuiContextMenuItem>,
		<EuiContextMenuItem
			key="workOrder"
			icon={<EuiIcon type={T3FleetIcon} size="m" />}
			href={workOrderURL}
			target="_blank"
		>
			View Work Orders <EuiIcon type={ShareBoxFillIcon} />
		</EuiContextMenuItem>,
		<EuiContextMenuItem
			key="branchTransfer"
			onClick={onClickTransferParts}
		>
				Create Branch Transfer
		</EuiContextMenuItem>,
		<EuiContextMenuItem
			key="exportCsv"
			onClick={onClickExportCSV}
		>
			{'Export Inventory (.CSV)'}
		</EuiContextMenuItem>,
		<EuiContextMenuItem
			key="exportAdjustmentsCsv"
			onClick={onClickExportAdjustmentsCSV}
		>
			{'Export Inventory Adjustments (.CSV)'}
		</EuiContextMenuItem>
	]

	return (
		<EuiPopover
			button={button}
			isOpen={isPopoverOpen}
			closePopover={closePopover}
		>
			<EuiContextMenuPanel items={items} />
		</EuiPopover>
	)
}
